/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import BaseWrapper from '../../components/base-wrapper';
import { showRatingStar } from './helpers';

const Edit = ( props ) => {
	const { isSelected, className, attributes } = props;
	const { textAlignment, blockClientId } = attributes;
	const wrapperClasses = classnames(
		className,
		`is-content-justification-${ textAlignment }`,
		`gutenify-section-${ blockClientId }`,
	);
	return <div className={ wrapperClasses }>
		{ isSelected && <Inspector { ...props } /> }
		<BaseWrapper { ...props }>
			{ showRatingStar( attributes ) }
		</BaseWrapper>
	</div>;
};

export default Edit;
